// extracted by mini-css-extract-plugin
export default {"image":"HeroCard_image_EpmTR"};